import { render, staticRenderFns } from "./brand-column.vue?vue&type=template&id=a3f1fc5c&scoped=true"
import script from "./brand-column.vue?vue&type=script&lang=js"
export * from "./brand-column.vue?vue&type=script&lang=js"
import style0 from "./brand-column.vue?vue&type=style&index=0&id=a3f1fc5c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f1fc5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3f1fc5c')) {
      api.createRecord('a3f1fc5c', component.options)
    } else {
      api.reload('a3f1fc5c', component.options)
    }
    module.hot.accept("./brand-column.vue?vue&type=template&id=a3f1fc5c&scoped=true", function () {
      api.rerender('a3f1fc5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/note/brand-column.vue"
export default component.exports